import OperationalTargetsCarousel from './OperationalTargetsCarousel';

import "./OperationalTargetsCarousel.scss";

export * from './OperationalTargetsCarousel.types';

export { OperationalTargetsCarousel };

